
export default function BlaBlaMission({data}) {
  if(!data){
    return null;
  }
  return (
    <>
      <section className="blabla-mission-area">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <span className="mission-label">
                {data.mission}
              </span>
            </div>

            <div className="col-lg-6 col-md-6">
              <div className="bla-bla-mission-head">
                <h2 className="heading">{data.titlePart1} <span className="gradiant-color">{data.titlePart2}</span> {data.titlePart3}</h2>
              </div>
            </div>

            <div className="col-lg-6 col-md-6">
              <div className="bla-bla-mission-head">
                <p>{data.description}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
